import React, { useState, useRef, useEffect, Fragment } from "react";
import {
    Col,
    Container,
    Form,
    Row,
    Table,
    Button,
    DropdownButton,
    ButtonGroup,
    Dropdown,
    Tabs,
    Tab,
    Modal,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import ReactLoading from "react-loading";

//components
import TableTemplate from "../../../Components/TableTemplate/Table";
import Navbar from "../../../Components/Navbar/Navbar";
import DeleteModal from "../../../Components/Modals/DeleteModal";
import AddModal from "../../../Components/Modals/AddModal";
import EditModal from "../../../Components/Modals/EditModal";
import ViewModal from "../../../Components/Modals/ViewModal";

//css
import "../../../Components/Navbar/Navbar.css";
import trash from "../../../Assets/Images/trash.png";
import plus from "../../../Assets/Images/plus.png";
import minus from "../../../Assets/Images/minus.png";

import { productsMockData } from "../../../Helpers/mockData/mockData";
import {
    getAllProducts,
    searchProduct,
    updateProductPriority
} from "../../../Helpers/apiCalls/Manage/Products";
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import toast from "react-hot-toast";
import { toastStyle, refreshPage, isAdmin, numberFormat } from "../../../Helpers/Utils/Common";
import { validateProducts } from "../../../Helpers/Validation/Manage/ProductsValidation";
import InputError from "../../../Components/InputError/InputError";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import { getSinkers, getAllAddOrderData, createOrder } from './../../../Helpers/apiCalls/Reports/DailyOrdersApi';
import { getAllDiscounts } from './../../../Helpers/apiCalls/Manage/DiscountsApi';
import { validateOrder } from './../../../Helpers/Validation/Order/OrderValidation';
import Footer from "../../../Components/Footer/Footer";


export default function ProductPriority() {
    let navigate = useNavigate();
    const {id, priceLevelId, date} = useParams()
    const [inactive, setInactive] = useState(false);
    const [option, setOption] = useState("Select");
    const [isClicked, setIsClicked] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [addOn, setAddOn] = useState("");

    const [sinkers, setSinkers] = useState([]);
    const [grabSinkers, setGrabSinkers] = useState([]);
    const [foodPandaSinkers, setFoodPandaSinkers] = useState([]);
    const [orders, setOrders] = useState([{ qty: "1", total: "0", sinker_total_price: "0", remarks: "",}]);
    const [orderDetails, setOrderDetails] = useState({
        branch_id: id,
        additional_discount: 0,
        active_discount: 0,
        subtotal: 0,
        delivery_fee: 0,
        grand_total: 0,
        transaction_type: "foodpanda",
        date: date, 
    });
    const [productsData, setProductsData] = useState();
    const [filteredProductsData, setFilteredProductsData] = useState();
    const [discounts, setDiscounts] = useState([]);
    const [activeDiscounts, setActiveDiscounts] = useState([]);
    const [searchProductName, setSearchProductName] = useState("");
    const [selectedRow, setSelectedRow] = useState({
        name: "",
        is_addon: "",
        items: [],
    });
    const [isChanged, setIsChanged] = useState(false);

    const [filterConfig, setFilterConfig] = useState({});
    const handleTabSelect = (tabKey) => {
        setAddOn("")
        setFilterConfig((prev) => {
            return { ...prev, 
                tab: tabKey,
                is_addon: "",
                search: "",
            };
        });
    };

    const [addTo, setAddTo] = useState("MANGO MAGIC");
    const handleAddSelect = (e) => {
        setAddTo(e);
    };

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        product_id: false,
        itemlist: false,
    });

    //API
    
    async function fetchFoodPandaData() {
        setShowLoader(true);
        setProductsData([]);

        const response = await getAllAddOrderData(id);
        
        if (response.data) {
            let foodpanda = response.data.data.foodpanda.products.map((a) => {
                var info = a;
                info.label = a.product_name + " - " + a.size
                info.value = a.id
                info.size = a.size.trim()
                var addons = []
                
                response.data.data.foodpanda.addons.map((addon) => {
                    var add = addon.map((data) => {
                        var addon_size = (data.size !== null && data.size !== undefined) ? data.size : data.whole_name.split(" - ")[1]?.trim()
                        if(info.size === addon_size) {
                            var details = data
                            details.sinker_qty = 0
                            addons.push(details)
                        }
                    })
                })
                info.addons = addons
                return info;
            });
            setProductsData(foodpanda);
            setFilteredProductsData(foodpanda);
            
            let discounts = response.data.data.foodpanda.discounts.map((a) => {
                var info = a;
                info.label = a.description
                info.value = a.id
                info.for = "discount_id"
                info.select_value = "discount_id_value"
                return info;
            });
            setDiscounts(discounts);
            
            setOrderDetails((prevState) => ({
                ...prevState,
                ["price_level_id"]: response.data.data.price_level_id,
                ["price_level_type_id"]: response.data.data.foodpanda.price_level_type_id,
            }));
            
        } else if (response.error) {
        }
        setShowLoader(false);
    }
    // 

    async function fetchGrabFoodData() {
        setShowLoader(true);
        setProductsData([]);

        const response = await getAllAddOrderData(id);
        
        if (response.data) {
            let grabfood = response.data.data.grabfood.products.map((a) => {
                var info = a;
                info.label = a.product_name + " - " + a.size
                info.value = a.id
                info.size = a.size.trim()
                var addons = []
                response.data.data.grabfood.addons.map((addon) => {
                    var add = addon.map((data) => {
                        var addon_size = (data.size !== null && data.size !== undefined) ? data.size : data.whole_name.split(" - ")[1]?.trim()
                        if(info.size === addon_size) {
                            var details = data
                            details.sinker_qty = 0
                            addons.push(details)
                        }
                    })
                })
                info.addons = addons
                return info;
            });
            setProductsData(grabfood);
            setFilteredProductsData(grabfood);
            
            let discounts = response.data.data.grabfood.discounts.map((a) => {
                var info = a;
                info.label = a.description
                info.value = a.id
                info.for = "discount_id"
                info.select_value = "discount_id_value"
                return info;
            });
            setDiscounts(discounts);

            setOrderDetails((prevState) => ({
                ...prevState,
                ["price_level_id"]: response.data.data.price_level_id,
                ["price_level_type_id"]: response.data.data.grabfood.price_level_type_id,
            }));
            
        } else if (response.error) {
        }
        setShowLoader(false);
    }

    async function handleAddOrder() {
        if (validateOrder(orders, setIsError)) {
            setIsClicked(true)
            const response = await createOrder(orderDetails, orders);
            
            if (response.data) {
                toast.success("Successfully added order!", {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    navigate(-1)
                }, 1000);
            } else {
                toast.error(response.error.response.data.messages.error, {
                    style: toastStyle(),
                });
            }
        }
    }

    function handleAddNewRow() {
        const newItem = { qty: "1", total: "0", sinker_total_price: "0", remarks: "", sinkers: [] };
        setOrders([...orders, newItem])
    }
    function handleRemoveOrder(id) {
        const rowId = id;
        const newProductList = [...orders];
        
        const updatedQty = 0;
        newProductList[rowId]["sinkers"]?.map((data, index) => {
            newProductList[rowId]["sinkers"][index] = {
            ...newProductList[rowId]["sinkers"][index], // Create a new copy of the object
            sinker_qty: updatedQty,
            };
        })

        newProductList.splice(rowId, 1);
        setOrders(newProductList);
    }
    
    function renderTable() {
        return (
            <Table className="align-middle">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Sinkers</th>
                        <th>Qty</th>
                        <th>Remarks</th>
                        <th>total</th>
                    </tr>
                </thead>
                <tbody>
                    {orders?.map((order, index) => {
                        return (
                            <tr>
                                <td>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select w-100"
                                        placeholder="Select products..."
                                        value={order.product_id_value}
                                        options={productsData}
                                        onChange={(e) => handleOrderChange(e, index, true)}
                                    />
                                </td>
                                <td>
                                    {
                                        order.sinkers?.map((sinker, sinkerindex) => {
                                            return (                              
                                                <Row className="mb-1">
                                                    <Col xs={5}>
                                                        <h1 className="edit-label"> {sinker.name} </h1>
                                                    </Col>
                                                    <Col xs={2}>
                                                        <div className="align-middle">
                                                            <button 
                                                                className={parseFloat(sinker.sinker_qty) === 0 ? "button-small-gray small-btn" : "button-small-green small-btn"}
                                                                onClick={(e) =>
                                                                    handleSinkersChange(e, sinker, index, sinkerindex, "minus")
                                                                }
                                                                name="sinker_qty"
                                                                >
                                                                -
                                                            </button>
                                                        </div>
                                                    </Col>
                                                    <Col xs={3}>
                                                        <Form.Control
                                                            type="number"
                                                            name="sinker_qty"
                                                            className="nc-modal-custom-input form-control"
                                                            value={sinker.sinker_qty}
                                                            onChange={(e) => handleSinkersChange(e, sinker, index, sinkerindex, "input")}
                                                            disabled
                                                        />
                                                    </Col>
                                                    <Col xs={2}>
                                                        <div className="align-middle">
                                                            <button 
                                                                className={order.sinkers.is_add_disabled ? "button-small-gray small-btn" : "button-small-green small-btn"}
                                                                onClick={(e) =>
                                                                    handleSinkersChange(e, sinker, index, sinkerindex, "plus")
                                                                }
                                                                name="sinker_qty"
                                                                >
                                                                +
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )
                                        })
                                    }
                                </td>
                                <td>                              
                                    <Row className="mb-1">
                                        <Col xs={4}>
                                            <div className="align-middle">
                                                <button 
                                                    className="button-small-green small-btn"
                                                    onClick={(e) => handleOrderChange(e, index, false)}
                                                    name="minus"
                                                    >
                                                    -
                                                </button>
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <Form.Control
                                                type="number"
                                                name="qty"
                                                min={1}
                                                className="nc-modal-custom-input form-control"
                                                value={order.qty}
                                                disabled
                                            />
                                        </Col>
                                        <Col xs={4}>
                                            <div className="align-middle">
                                                <button 
                                                    className="button-small-green small-btn"
                                                    onClick={(e) => handleOrderChange(e, index, false)}
                                                    name="plus"
                                                    >
                                                    +
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Form.Control
                                        type="number"
                                        name="qty"
                                        min={1}
                                        className="nc-modal-custom-input form-control"
                                        value={order.qty}
                                        onChange={(e) => handleOrderChange(e, index, false)}
                                    /> */}
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="remarks"
                                        className="nc-modal-custom-input form-control"
                                        value={order.remarks}
                                        onChange={(e) => handleOrderChange(e, index, false)}
                                    />
                                </td>
                                <td>{numberFormat(order.total)}</td>
                                <td>
                                    <div className="align-middle">
                                        <img
                                            src={trash}
                                            alt="delete"
                                            onClick={() =>
                                                handleRemoveOrder(index)
                                            }
                                            className="cursor-pointer"
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }
    
    const handleOrderDetailsChange = (e, search) => {
        if(search) {
            
            if(e.select_value === "discount_id_value") {
                setOrderDetails((prevState) => ({
                    ...prevState,
                    [e.select_value]: { label: e.label, value: e.value },
                    [e.for]: e.value,
                    ["active_discount"]: e.discount_amount,
                }));
            } else {
                setOrderDetails((prevState) => ({
                    ...prevState,
                    [e.select_value]: { label: e.label, value: e.value },
                    [e.for]: e.value,
                }));
            }
        } else {
            const { name, value } = e.target;
            if(name === "transaction_type") {
                if(value === "foodpanda") {
                    setOrderDetails((prevState) => ({
                        ...prevState,
                        [name]: value,
                    }));
                    fetchFoodPandaData()
                } else {
                    setOrderDetails((prevState) => ({
                        ...prevState,
                        [name]: value,
                    }));
                    fetchGrabFoodData()
                }
            } else {
                setOrderDetails((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            }
        }
    };

    function handleOrderChange(e, index, search) {
        setIsChanged(true)
        
        if(search) {
            const list = [...orders];

            const newSinkerObjects = e.addons.map((sinker) => {
                return { ...sinker };
            });
          
            list[index].product_id_value = { label: e.label, value: e.value };
            list[index].product_id = e.value;
            list[index].product_name = e.label;
            list[index].sinkers = newSinkerObjects;
            list[index].price = e.price;
            list[index].total = e.price;

            setOrders(list);
            
        } else {
            const { name, value } = e.target;
            
            if(name === "plus") {
                const list = [...orders];
                list[index]["qty"] = parseFloat(list[index]["qty"]) + 1;
                list[index]["total"] = (parseFloat(list[index]["sinker_total_price"]) + parseFloat(list[index]["price"])) * parseFloat(list[index]["qty"])
                
                setOrders(list);
            } else if(name === "minus") {
                const list = [...orders];
                if(parseFloat(list[index]["qty"]) > 1) {
                    list[index]["qty"] = parseFloat(list[index]["qty"]) - 1;
                    list[index]["total"] = (parseFloat(list[index]["sinker_total_price"]) + parseFloat(list[index]["price"])) * parseFloat(list[index]["qty"])
                    
                    setOrders(list);
                }
            } else {
                const list = [...orders];
                list[index][name] = value;
        
                setOrders(list);
            }
        }
        setTimeout(() => {
            setIsChanged(false)
        }, 1000);
    }
    
    
    

    const handleSinkersChange = (e, sinker, index, sinkerindex, method) => {
        setIsChanged(true)
        const { name, value } = e.target;
        
        
      
        const list = [...orders];
        //getting the total qty of sinkers
        var sinkertotal = list[index]["sinkers"]
          .map((sink) => parseFloat(sink.sinker_qty))
          .reduce((a, b) => a + b, 0);
      
        if (sinkertotal >= 2 && method === "plus") {
          list[index]["sinkers"]["is_add_disabled"] = true;
        } else {
            list[index]["sinkers"]["is_add_disabled"] = false;
            if (method === "plus") {
                const updatedQty = parseFloat(list[index]["sinkers"][sinkerindex].sinker_qty) + 1;
                list[index]["sinkers"][sinkerindex] = {
                ...list[index]["sinkers"][sinkerindex], // Create a new copy of the object
                sinker_qty: updatedQty,
                };
            } else if (method === "minus") {
                if (parseFloat(list[index]["sinkers"][sinkerindex].sinker_qty) > 0) {
                const updatedQty = parseFloat(list[index]["sinkers"][sinkerindex].sinker_qty) - 1;
                list[index]["sinkers"][sinkerindex] = {
                    ...list[index]["sinkers"][sinkerindex], // Create a new copy of the object
                    sinker_qty: updatedQty,
                };
                }
            }
            // Calculating the price of the sinkers
            var totalPriceOfSinkers = list[index]["sinkers"]
                .map((sink) => {
                    const sinkerQty = parseFloat(sink.sinker_qty);
                    return sinkerQty > 0 ? sinkerQty * sink.price : 0;
                })
                .reduce((a, b) => a + b, 0);
                //setting the price of sinker and calculating the total
                list[index]["sinker_total_price"] = totalPriceOfSinkers
                list[index]["total"] = (totalPriceOfSinkers + parseFloat(list[index]["price"])) * parseFloat(list[index]["qty"])

            //checking again the sinker qty to disable button if > 2
            var sinkerQty = list[index]["sinkers"]
                .map((sink) => parseFloat(sink.sinker_qty))
                .reduce((a, b) => a + b, 0);
            if (sinkerQty >= 2) {
                list[index]["sinkers"]["is_add_disabled"] = true;
            } else {
                list[index]["sinkers"]["is_add_disabled"] = false;
            }
        }
        
        setOrders(list);
        setTimeout(() => {
            setIsChanged(false)
        }, 100);
      };
    // 

    // to filter products that are already selected
    const filteredProducts = productsData?.filter((product) => {
        // Check if the product is present in orders
        const productInOrders = orders.some((order) => order.product_id === product.id);
        // Return true to keep the product if it's not in orders, false otherwise
        return !productInOrders;
    });
    // 
    // 
        
    useEffect(() => {
        fetchFoodPandaData();
        // fetchProducts();
        // fetchSinkers();
        // fetchDiscounts();
        
    }, []);

    useEffect(() => {
        // to set filtered products
        setFilteredProductsData(filteredProducts)
    }, [orders]);
    
    useEffect(() => {
        var _subtotal = orders
            .map((item) => parseFloat(item.total))
            .reduce((a, b) => a + b, 0);

        var _grandTotal = _subtotal + parseFloat(orderDetails.delivery_fee) - parseFloat(orderDetails.additional_discount) - parseFloat(orderDetails.active_discount);
        setOrderDetails((prev) => {
            return {
                ...prev,
                subtotal: _subtotal.toFixed(2),
                grand_total: _grandTotal,
            };
        });
    }, [isChanged, orderDetails.additional_discount, orderDetails.delivery_fee, orderDetails.active_discount]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-3">
                    <Col xs={6}>
                        <h1 className="page-title"> ADD ORDER </h1>
                    </Col>
                </Row>
                <div className="edit-form mb-5">
                    <Fragment>
                        <div className="my-2 px-2 PO-filters d-flex">
                            <span className="me-4 align-middle mt-2 ps-label">
                                Transaction Type:
                            </span>
                            <Form.Select
                                name="transaction_type"
                                className="date-filter me-2"
                                value={orderDetails.transaction_type}
                                onChange={(e) => handleOrderDetailsChange(e)}
                            >
                                <option value="" disabled hidden selected>
                                    Select
                                </option>
                                {/* <option value="store"> Store </option> */}
                                <option value="foodpanda"> Food Panda </option>
                                <option value="grabfood"> Grab Food </option>
                            </Form.Select>

                        </div>
                        <Row className="nc-modal-custom-row">
                            <div className="edit-purchased-items">
                                {orders.length === 0 ? (
                                    <span>No Order Found!</span>
                                ) : (
                                    renderTable() 
                                )}
                            </div>
                            <InputError
                                isValid={isError.product_id}
                                message={"Product is required"}
                            />
                            <InputError
                                isValid={isError.itemlist}
                                message={"Please add at least 1 product"}
                            />
                        </Row>
                        <Row className="pt-3 PO-add-item">
                            <Button type="button" 
                                onClick={handleAddNewRow}
                                >
                                Add Item
                            </Button>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <span className="me-4 align-middle mt-2 color-gray grand-total-text">
                                    PAYMENTS
                                </span>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Transaction Method
                                        </span>
                                    </Col>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            {orderDetails.transaction_type}
                                        </span>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Payment method
                                        </span>
                                    </Col>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Credit
                                        </span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Active Discount
                                        </span>
                                    </Col>
                                    <Col>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select w-100"
                                            placeholder="Select discount..."
                                            value={orderDetails.discount_id_value}
                                            options={discounts}
                                            onChange={(e) => handleOrderDetailsChange(e, true)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            {/* <Col xs={6}>
                            </Col> */}
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Additional Discount
                                        </span>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="text"
                                            name="additional_discount"
                                            className="nc-modal-custom-input form-control"
                                            value={orderDetails.additional_discount}
                                            onChange={(e) => handleOrderDetailsChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Code
                                        </span>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="text"
                                            name="code"
                                            className="nc-modal-custom-input form-control"
                                            value={orderDetails.code}
                                            onChange={(e) => handleOrderDetailsChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Reference No.
                                        </span>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            name="reference_no"
                                            className="nc-modal-custom-input form-control"
                                            value={orderDetails.reference_no}
                                            onChange={(e) => handleOrderDetailsChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Delivery Fee.
                                        </span>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            name="delivery_fee"
                                            className="nc-modal-custom-input form-control"
                                            value={orderDetails.delivery_fee}
                                            onChange={(e) => handleOrderDetailsChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Or No.
                                        </span>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            name="or_no"
                                            className="nc-modal-custom-input form-control"
                                            value={orderDetails.or_no}
                                            onChange={(e) => handleOrderDetailsChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row>
                                    <Col>
                                        <span className="edit-label color-gray">
                                            Remarks
                                        </span>
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="text"
                                            name="remarks"
                                            className="nc-modal-custom-input form-control"
                                            value={orderDetails.remarks}
                                            onChange={(e) => handleOrderDetailsChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Fragment>
                            <Row className="align-right pt-3 mt-4">
                                <Col xs={2} className="text-end">
                                    <span className="edit-label color-gray">
                                        Subtotal
                                    </span>
                                </Col>
                                <Col xs={1} className="text-end">
                                    <span className="edit-label align-middle">
                                        PHP
                                    </span>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <span className="edit-label align-middle">
                                        {numberFormat(orderDetails?.subtotal)}
                                    </span>
                                </Col>
                            </Row>
                            <Row className="align-right pt-3">
                                <Col xs={2} className="text-end">
                                    <span className="edit-label color-gray">
                                        Active Discount
                                    </span>
                                </Col>
                                <Col xs={1} className="text-end">
                                    <span className="edit-label align-middle">
                                        PHP
                                    </span>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <span className="edit-label align-middle red">
                                        -{numberFormat(orderDetails?.active_discount)}
                                    </span>
                                </Col>
                            </Row>
                            <Row className="align-right pt-3">
                                <Col xs={2} className="text-end">
                                    <span className="edit-label color-gray">
                                        Additional Discount
                                    </span>
                                </Col>
                                <Col xs={1} className="text-end">
                                    <span className="edit-label align-middle">
                                        PHP
                                    </span>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <span className="edit-label align-middle red">
                                        -{numberFormat(orderDetails?.additional_discount)}
                                    </span>
                                </Col>
                            </Row>
                            <Row className="align-right pt-3">
                                <Col xs={2} className="text-end">
                                    <span className="edit-label color-gray">
                                        Delivery Fee
                                    </span>
                                </Col>
                                <Col xs={1} className="text-end">
                                    <span className="edit-label align-middle">
                                        PHP
                                    </span>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <span className="edit-label align-middle">
                                        +{numberFormat(orderDetails?.delivery_fee)}
                                    </span>
                                </Col>
                            </Row>
                            <Row className="align-right py-5">
                                <Col xs={2} className="text-end">
                                    <span className="edit-label color-gray grand-total-text">
                                        Grand Total
                                    </span>
                                </Col>
                                <Col xs={1} className="text-end">
                                    <span className="edit-label align-middle grand-total-text">
                                        PHP
                                    </span>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <span className="edit-label align-middle grand-total-text">
                                        {numberFormat(
                                            orderDetails?.grand_total
                                        )}
                                    </span>
                                </Col>
                            </Row>
                        </Fragment>
                        <Row>
                            <Col className="d-flex justify-content-end mt-2 mb-0">
                                <button
                                    type="button"
                                    className="button-secondary justify-content-end me-3"
                                    onClick={() => navigate(-1)}
                                >
                                    Close
                                </button>
                                {isClicked ? (
                                    <div className="button-primary d-flex justify-content-center">
                                        <ReactLoading
                                            type="bubbles"
                                            color="#FFFFFF"
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className="button-primary justify-content-end"
                                        onClick={() => handleAddOrder()}
                                    >
                                        Add Order
                                    </button>
                                )}
                            </Col>
                        </Row>
                    </Fragment>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
